var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-slide-page"},[_c('sys-bar',{ref:"sysBar",attrs:{"backable":true}}),_c('div',{ref:"content",staticClass:"content-wrapper"},[_c('transition-slide',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }